import { render } from "./Test.vue?vue&type=template&id=726f8aa9"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import exportComponent from "/home/jeim2750/staging.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__